import React from 'react';
import { withAuthorization } from '../Session';
import { Container, Row, Col, Button, View ,Form} from 'react-bootstrap';
import './style.css';

class RefundPolicy extends React.Component {
    _isMounted = false;
    state = {
        
    };

    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
     }
    
    
    render() {
        
        return (
            <Container className="page_content">
            <Row>
                <h1>FAQs</h1>
<h3>Gift Card Basics</h3>
<h4>How do I order a Gift Card or an E-Gift Card?</h4>
<p>Ordering a Gift Card or an E-Gift Card through Indiabuys is easy. Once you select your favorite brand, select the card type. You can choose from Gift Card, E-Gift Card or Gift Voucher. Enter the denomination and quantity you wish to purchase. Click on the "Buy now" button and you will be directed to the Checkout page. In the Checkout page you just need to enter the billing, shipping details and choose the suitable payment mode to complete your purchase.
</p>
<h4>Where are these Gift Cards accepted?</h4>

<p>Usage of a Gift Card or an E-Gift Card is dependent on the brand's Terms and Conditions. Gift Cards are accepted in all the participating retail outlets of a particular brand. Any limitations or special cases will be specified in the 'Terms & Conditions' tab on the particular Gift Card.
</p>
<h4>Can Gift Cards or E-Gift Cards be recharged after purchase?</h4>

<p>The recharge of the Gift Card is dependent on the brand's terms and conditions. If allowed, recharge can be done through any participating retail outlet of the brand that's located in your city.
</p>
<p>E-Gift Cards cannot be recharged.</p>

<h4>Does a Gift Card have an expiry date?</h4>
<p>Gift Cards or E-Gift Cards typically have a validity period of 3 to 12 months. However, the validity period might change according to the brand or retailer.
</p>
<p>Take a look at the Terms & Conditions provided in the product page before you buy the item and proceed to the payment portal.
</p>


<h4>How can I update the card balance of gift cards in my Indiabuys Account?</h4>
<p>Card balance can be updated in 3 simple steps.</p>
<ul>
<li>1. Login to Indiabuys, check 'Your account'</li>
<li>2. Click on the respective gift card for which the balance needs to be updated.</li>
<li>3. Click on the refresh button available on the card. Balance will be updated.</li>
</ul>

<h4>How many Gift Cards can I order in one purchase?</h4>
<p>
You can order up to 10 units in one purchase. In the product details page, enter the required units in the quantity field. However, some gift cards can have a different max quantity limit, which will be available on the gift card purchase page.
</p>
<p>Corporate bulk orders for festive occasions are common. For Corporate Gift Cards, you can also contact our sales team at info@indiabuys.store
</p>
<h4>Are there any terms and conditions involved?</h4>
<p>The terms and conditions for each brand Gift Card or E-Gift Card can differ, so review the Terms and conditions and overall details before you choose a Gift Card. This will give you a very clear idea and help you with your decision.
</p>
<p>What do I do if my Gift Card is stolen/ there is fraud detected in relation to my Gift Card?
</p>
<p>
In the event of loss or theft of card or authentication data or in the event of any fraud/abuse being detected, the customer can send an e-mail at info@indiabuys.store or whatsapp us at 6301476353 during the business hours (9 am - 11 pm) .
</p>

<h4>What is the difference between a Gift Card & a Gift Voucher?</h4>
<table>
<thead>
<tr>
<td>Gift Card</td><td>Gift Voucher</td>
</tr>
</thead>
<tbody>
<tr>
<td>
<ul>
<li>1. It look & feel is similar to any ATM or a debit card.</li>
<li>2. Can be redeemed in multiple purchases.</li>
<li>3. Unused funds will remain intact in the card for further use.</li>
<li>4. Can be reused by reloading with funds from brand retail outlets.</li>

</ul>
</td>
<td>
<ul>
<li>1. It is a classic printed paper.</li>
<li>2. Need to be used for the full extent in single purchase.</li>
<li>3. Unused funds will go in vain.</li>
<li>4. Each voucher is only for single use.</li>

</ul>
</td>
</tr>
</tbody>
</table>

<h4>Are there any minimum security requirements/precautions that I would need to take in respect of the Gift Cards?</h4>

<p>You shall, at all times, keep the passwords that are created by you or your customers/beneficiaries on the Website, and the Gift Card Pin, strictly confidential and not reveal the same to any person or entity.
 </p>
<h3>Payment Options</h3>
<h4>How do I pay for a gift card?</h4>
<p>We support different modes of payment, including credit cards, debit cards and internet banking. Check the payment options in the "Check out" page. 
</p>
<h4>Are there any hidden charges or taxes?</h4>
<p>At Indiabuys, you pay the price that's mentioned in the checkout page – that's all.
</p>
<p>There are absolutely no hidden charges or taxes and what you get is what you see.
</p>
<h4>Will I receive an invoice along with the order?</h4>
<p>Yes, you will receive invoices with order.</p>
<p>An email regarding the sales invoice will be sent to the buyer soon after the purchase. </p>
<p>You can use this invoice for future claims, if any.</p>

<h4>Will I receive confirmation after placing an order?</h4>
<p>Yes, you will receive the confirmation through E-mail & also via SMS.</p>

<h4>Whom do I contact for doubts related to payments?</h4>
<p>For clarity on payment related issues, feel free to whatsapp our support team at: 6301476353</p>
<p>Or write to us at info@indiabuys.store</p>
<p>Or chat with our customer care executive available on the website.</p>

<h3>Order Status</h3>
<h4>How do I check the status of my order?</h4>
<p>
Every order placed in woohoo.in is provided with a unique order number. Your order number will be sent through email as soon as you place the order, along with the sales invoice. Regular email updates will be sent regarding the status of your order.
</p>
<h4>Whom do I contact for enquiring about the status?</h4>
<p>
For detailed assistance and verbal reports about the status of your order, our customer support executives will be available on whatsapp on 6301476353. Alternatively, you can send a mail to info@indiabuys.store. Or chat with our customer care executive available on the website.
</p>
<h3>Gift Card Refunds</h3>
<h4>Can I cancel my order?</h4>
<p>Gift Cards/E-Gift Cards/Gift Vouchers once ordered cannot be canceled. </p>

<h4>Will I get a refund if the wrong card is delivered?</h4>
<p>
If you find that the wrong Gift Card has been delivered to you, contact us immediately in order to get the issue resolved.
</p>
<p>
You can send an email to info@indiabuys.store and we will immediately take the corrective action, if required. 
</p>
</Row>
                        
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(RefundPolicy);
